import {React, useState, useEffect} from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";

import Api from './component/api';
import Layout  from './component/Layout';
import ScrollToTop from "./component/ScrollToTop";
import Contact  from './pages/Contact';


import Home from './pages/Home';
import NotFoundPage from './pages/NotFoundPage';

//import Category from './component/category';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import Content from './pages/Content';
import SearchPage from './pages/SearchPage';
import EmploymentFormPage from './pages/EmploymentFromPage';
import ContactUs from './pages/ContactUs';
import PrestashopPage from "./pages/PrestashopPage";

const PathChecker = ({ setPathInfo }) => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const productUrl = path.includes(".html");
    const id = path.split("-")[0].replace("/", "");
    setPathInfo({ productUrl, id });
  }, [location, setPathInfo]);

  return null; // چیزی نمایش نمی‌دهد
};
function App() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [pathInfo, setPathInfo] = useState({ productUrl: false, id: "" });

  useEffect(() => {
   /* const fetchData = async () => {
      try {
          const result = Api("products",'86062'); // فراخوانی برای یک محصول خاص
          
          setData(result);
        } catch (err) {
          setError(err); // مدیریت خطا
      }
    };

    fetchData(); */
  }, []);

  return (
    
    <BrowserRouter>
     <PathChecker setPathInfo={setPathInfo} />
     <ScrollToTop />
      <Routes>
        
        <Route path="/" element={<Layout />}>
        
          <Route index element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/employmentform" element={<EmploymentFormPage />} />
          <Route 
          path=":id" 
          element={ pathInfo.productUrl ? <ProductPage productId={pathInfo.id} /> : <CategoryPage categoryId={pathInfo.id} />} 
          />
          
          <Route path="/content/:id" element={<Content />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/cart" element={<PrestashopPage  url='/cart?action=show'/>} />
           
          <Route path="*" element={<NotFoundPage />} />
          
        </Route>
      </Routes>
    
    </BrowserRouter>
  );
}

export default App;
